import Value from './NewOrPromoSection'
import Form from './NewOrPromoForm'

export default {
	label: 'New or promotion houses',
	group: 'content',
	Value,
	Form,
}
